import React from 'react';
import PropTypes from 'prop-types';

const ProjectDetails = ({ projectInfo }) => {
  return (
    <a
      href={`/projects/${projectInfo.databaseId}`}
      className="project-name-wrap"
      data-testid="asset__project-details"
    >
      <div className="project-address">{projectInfo.formattedLine1}</div>
      <div className="project-city-state">{projectInfo.formattedLine2}</div>
    </a>
  );
};

ProjectDetails.propTypes = {
  projectInfo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    databaseId: PropTypes.string.isRequired,
    formattedLine1: PropTypes.string.isRequired,
    formattedLine2: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProjectDetails;
